import { api } from "./api";

export async function getStatistic(lokalString: string, date: string) {
    try {
        const response = await api.get(`statistic/${lokalString}`, {
            withCredentials: true,
            headers: {
                "Content-Type": "application/json",
            },
            params: {
                date: date,
            },
        });
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return { message: "Щось пішло не так" };
        }
    }
}
